/** Native button supports Enter/Space. aria-pressed=true means actively playing. */
class TdpHeroVideo extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const video = this.querySelector('video'), button = this.querySelector('button');
    if (!video || !button) return;
    const sync = () => {
      const playing = !video.paused;
      button.setAttribute('aria-pressed', String(playing));
      button.textContent = playing ? 'Video pauzeren' : 'Video afspelen';
      button.setAttribute('aria-label', button.textContent);
    };
    const options = { signal: this.controller.signal };
    const play = () => video.play().catch(sync);
    button.addEventListener('click', () => { if (video.paused) play(); else video.pause(); }, options);
    video.addEventListener('play', sync, options);
    video.addEventListener('pause', sync, options);
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.motion.addEventListener('change', () => { if (this.motion.matches) video.pause(); }, options);
    video.pause();
    sync();
    if (!this.motion.matches) play();
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = null; }
}
if (!customElements.get('tdp-hero-video')) customElements.define('tdp-hero-video', TdpHeroVideo);
